// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["assets/css/main"], () => (__webpack_require__("./resource/js/main.js")))
__webpack_require__.O(undefined, ["assets/css/main"], () => (__webpack_require__("./resource/css/main.scss")))
var __webpack_exports__ = __webpack_require__.O(undefined, ["assets/css/main"], () => (__webpack_require__("./resource/css/tailwind.css")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
